<script setup lang="ts">
  import {
    sidePanelHeaderClass,
    sidePanelHeaderSubtitleClass,
    sidePanelHeaderTitleClass,
  } from './SidePanelHeader.css';

  defineProps<{ title: string; subtitle?: string }>();
</script>

<template>
  <div :class="sidePanelHeaderClass">
    <h1 :class="sidePanelHeaderTitleClass"><slot>{{ title }}</slot></h1>
    <h3
      v-if="subtitle || $slots.subtitle"
      :class="sidePanelHeaderSubtitleClass"
    >
      <slot name="subtitle">{{ subtitle }}</slot>
    </h3>
  </div>
</template>
